export default __webpack_public_path__ + "static/media/character_pass_placeholder.a765a164.gif";